import { render, staticRenderFns } from "./add-contract-info.vue?vue&type=template&id=00ff2e73&"
import script from "./add-contract-info.vue?vue&type=script&lang=js&"
export * from "./add-contract-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports